export default {
  VOD: 'VOD',
  SERIES: 'SERIES',
  CHANNEL: 'CHANNEL',
  VOD_CHANNEL: 'VOD_CHANNEL',
  CATCHUP: 'CATCHUP',
  TRAILER: 'TRAILER',
  TIMESHIFT: 'TIMESHIFT',
};
